module.exports = __webpack_public_path__ + "static/media/Weight.1e6e6f76.png";